import React from 'react';
import { useDispatch } from 'react-redux';
import { FormattedDate } from 'react-intl';
import {
	Button,
	DialogContent,
	DialogTitle,
	DialogActions,
	TableContainer,
	Table,
	TableRow,
	TableCell,
	TableBody,
	Paper
} from '@mui/material';

import { closeDialog, openDialog } from 'app/store/fuse/dialogSlice';
import { useSettings, Utils } from 'app/main/components';

interface DemsRecipientsOpenDetailsDialogProps {
	opens: any[];
}

export function showDemsRecipientsOpenDetailsDialog(props: DemsRecipientsOpenDetailsDialogProps) {
	return openDialog({
		children: <DemsRecipientsOpenDetailsDialog {...props} />,
		maxWidth: 'sm',
		fullWidth: true
	});
}

export default function DemsRecipientsOpenDetailsDialog({ opens }: DemsRecipientsOpenDetailsDialogProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();

	return (
		<>
			<DialogTitle>{t('DIALOG_TITLE_RECIPIENTS_OPEN_DETAILS')}</DialogTitle>
			<DialogContent>
				<TableContainer component={Paper} variant="outlined">
					<Table className="tabular-nums" size="small">
						<TableBody>
							{opens.map(open => (
								<TableRow
									key={open.dopn_uid}
									sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
								>
									<TableCell>{open.dopn_ip}</TableCell>
									<TableCell align="right">
										<FormattedDate
											value={Utils.parseDate(open.dopn_date)?.toDate()}
											year="numeric"
											month="numeric"
											day="numeric"
											hour="numeric"
											minute="numeric"
											second="numeric"
										/>
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => dispatch(closeDialog())}>{t('DIALOG_ACTION_CLOSE')}</Button>
			</DialogActions>
		</>
	);
}
